var React = require( 'react' );
var createReactClass = require('create-react-class');
var Section = require( './section.jsx' );
var PureRenderMixin = require('react-addons-pure-render-mixin');

var Topic = createReactClass( {
	mixins: [PureRenderMixin],
	render: function () {
		var sections = this.props.sections.filter(function(item) {
			return item.format !== 'video';
		}).map(function(item, i) {
		      return (
		          <Section section={item} key={'section-' + i} />
		      );
	    });
		return (
			<section className="topic" data-magellan-target={this.props.arrival + '-topic'} id={this.props.arrival + '-topic'}>
			    <h2 title={this.props.title}>
					{this.props.title}
				</h2>
			    {sections}
			</section>
		)
	}
});

module.exports = Topic;



// WEBPACK FOOTER //
// ./src/common/routes/education/components/layout/topic.jsx